import { render, staticRenderFns } from "./MajorChoose.vue?vue&type=template&id=056d1994&scoped=true&"
import script from "./MajorChoose.vue?vue&type=script&lang=js&"
export * from "./MajorChoose.vue?vue&type=script&lang=js&"
import style0 from "./MajorChoose.vue?vue&type=style&index=0&id=056d1994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d1994",
  null
  
)

export default component.exports